import localesEs from '@/views/Auth/i18n/localeEs';

export default {
  es: {
    ...localesEs.es,
    SEO_TITLE: 'Olvidaste tu contraseña',
    SEO_DESCRIPTION: 'No te preocupes. A todos nos puede pasar.',
    FORM_TITLE: 'Restablece contraseña',
    FORM_DESCRIPTION:
      'Ingresa la dirección de correo electrónico que usaste cuando te uniste y te enviaremos instrucciones para restablecer tu contraseña.',
    INPUT_EMAIL_LABEL: 'Correo',
    INPUT_EMAIL_HINT: 'Ingresa tu correo',
    BUTTON_SUBMIT_LABEL: 'Enviar',
    SUCCESS_TITLE: '¡Listo!',
    SUCCESS_DESCRIPTION:
      'Te acabamos de enviar un correo con las instrucciones a \n [{{email}}](mailto:{{email}}). Sigue las instrucciones para restablecer tu contraseña.',
    BUTTON_SUCCESS_LABEL: 'Iniciar sesión',
  },
};
